/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Comparison applied between a column and a literal value.

 - COMPARISON_OPERATOR_UNSPECIFIED: Default; unset operator.
 - COMPARISON_OPERATOR_EQUAL: Column equals the value.
 - COMPARISON_OPERATOR_NOT_EQUAL: Column differs from the value.
 - COMPARISON_OPERATOR_LESS_THAN: Column is less than the value.
 - COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL: Column is less than or equal to the value.
 - COMPARISON_OPERATOR_GREATER_THAN: Column is greater than the value.
 - COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL: Column is greater than or equal to the value.
 - COMPARISON_OPERATOR_HAS: Column contains the value as a substring.
 - COMPARISON_OPERATOR_IN: Column matches one of the members of a list value.
 */
export type V1ComparisonOperator =
  (typeof V1ComparisonOperator)[keyof typeof V1ComparisonOperator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1ComparisonOperator = {
  COMPARISON_OPERATOR_UNSPECIFIED: 'COMPARISON_OPERATOR_UNSPECIFIED',
  COMPARISON_OPERATOR_EQUAL: 'COMPARISON_OPERATOR_EQUAL',
  COMPARISON_OPERATOR_NOT_EQUAL: 'COMPARISON_OPERATOR_NOT_EQUAL',
  COMPARISON_OPERATOR_LESS_THAN: 'COMPARISON_OPERATOR_LESS_THAN',
  COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL:
    'COMPARISON_OPERATOR_LESS_THAN_OR_EQUAL',
  COMPARISON_OPERATOR_GREATER_THAN: 'COMPARISON_OPERATOR_GREATER_THAN',
  COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL:
    'COMPARISON_OPERATOR_GREATER_THAN_OR_EQUAL',
  COMPARISON_OPERATOR_HAS: 'COMPARISON_OPERATOR_HAS',
  COMPARISON_OPERATOR_IN: 'COMPARISON_OPERATOR_IN',
} as const;
